import { __rest } from "tslib";
import * as React from "react";
import { forwardRef } from "react";
import clsx from 'clsx';
const _CaretDownIcon = (_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return React.createElement("svg", Object.assign({ fill: "currentColor", viewBox: "0 0 24 24", role: "presentation", width: 16, height: 16, className: clsx("cmp-icon", className), ref: ref }, props),
        React.createElement("path", { d: "M16.814 9.198a.662.662 0 0 1 .186.469c0 .18-.062.337-.186.469l-4.374 4.666A.583.583 0 0 1 12 15a.583.583 0 0 1-.44-.198l-4.374-4.666A.662.662 0 0 1 7 9.665a.66.66 0 0 1 .186-.468.583.583 0 0 1 .44-.197h8.75a.58.58 0 0 1 .438.198Z" }));
};
const CaretDownIcon = forwardRef(_CaretDownIcon);
export default CaretDownIcon;
//# sourceMappingURL=caret-down.js.map